import createApiServices from "./createApiServices"

const prefixURL = process.env.REACT_APP_URL_FULFILLMENT ? `${process.env.REACT_APP_URL_FULFILLMENT}/api` : 'https://fulfillment-staging.merchize.com/api'
const api = createApiServices({baseUrl: prefixURL})

export const getListRequests = (data) => {
    return api.makeAuthRequest({
        url: '/platform/list-request/search',
        method: 'POST',
        data,
    })
}